import {
    handle,
    loader,
    shouldRevalidate,
    default as ProfessionalInfoLayout,
} from '~/routes/_app.professional.$urlSegment.info';

export { loader, handle, shouldRevalidate };
export default ProfessionalInfoLayout;
